import React from "react";
import { Link } from "react-router-dom";

export default function ArticleCard({ article, compact = false }) {
  return (
    <Link className={`ro-editorial ${compact ? "ro-editorial--compact" : ""}`} to={`/pairings/${article.id}`}>
      <img src={article.image} alt={article.imageAlt} width="600" height="400" loading="lazy" />
      <h3>{article.title}</h3>
      <p>{article.desc}</p>
      <span className="ro-editorial__meta">{article.category} · Pairing idea · 2 min read</span>
    </Link>
  );
}
